import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import VehiculeService from '../services/VehiculeService';
import { Dropdown } from 'primereact/dropdown';
import { itemPerPage } from '../baseUrls/consts';

const EtatMateriel = () => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('EN_BON_ETAT');
    const [loading, setLoading] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        VehiculeService.get((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {etatVehicule: globalFilter}
        );
    }

    //alert(globalFilter)
    const choice = [
        {label: 'EN BON ÉTAT', value: 'EN_BON_ETAT'},
        {label: 'EN PANNE', value: 'EN_PANNE'},
        {label: "HORS D'USAGE", value: 'HORS_USAGE'}
    ]
   
    return (
        <>
            <h5>Etat des véhicules</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <span className="block mt-6 md:mt-0 p-input-icon-left mr-2">
                            <Dropdown value={globalFilter} options={choice} optionLabel="label" 
                                onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Sélectionner" />
                        </span>
                        <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                            onClick={()=>{setLoading(true); loadItems()}} />
                    </React.Fragment>
                }  />
                
                
            <DataTable dataKey="id" value={items} 
                paginator rows={itemPerPage} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange} */ 
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" sortable  hidden />
                <Column field="immatriculation" header="Immatriculation" sortable />
                {/*<Column field="libelle" header="Libellé" sortable />*/}
                <Column field="marque" header="Marque" sortable />
                <Column field="modele" header="Modèle" sortable />
                <Column field="nbrePlace" header="Nombre de places" sortable />
                <Column field="etatVehicule" header="Etat" sortable body={ (item)=> 
                    <span className={`customer-badge status-${item.etatVehicule === 'EN_BON_ETAT'? 'qualified' : 'unqualified'}`}>
                        {item.etatVehicule}
                    </span>
                } />
                <Column field="institution.libelle" header="Institution" sortable />
            </DataTable>
        </>
    );
}


export default EtatMateriel;